import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../../components/feature/Header';
import Footer from '../../../../components/feature/Footer';

const OkadaManabuPage = () => {
  // ページ読み込み時のスクロール処理を削除
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const testimonial = {
    name: '岡田 学',
    title: '代表取締役',
    company: '株式会社イビリス',
    image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/2f9f9198753682b69ba4c9262eb11081.png',
    sections: [
      {
        question: '私を利用する前にどんなことで悩んでましたか？',
        answer: '会社作ることは出来たけどその後、税金どうしたらいいか分からなかった。自分の給料、どのくらいとったらいいとか。あと税金面で法人税や個人の税金など、それにちゃんとどうやって対応したらいいのかが全く見えなかったと、で、悩んでました。'
      },
      {
        question: 'いつどんなきっかけで興味を持ちましたか？',
        answer: '要は会社設立のときに、税金っていうのが必要でこの税理士さんっていう分野に興味を持ちました。'
      },
      {
        question: 'この商品をいつどこで知りましたか？',
        answer: '前から赤石さんとか、セミナーで知り合って、そのときの第一印象は。変な人やなと思いました。'
      },
      {
        question: 'この商品を買おうとしたとき他社と比べましたか？',
        answer: 'いえ、比べてません。赤石さん見たいな税理士はいなかったから。'
      },
      {
        question: '最終的にこの商品を選んだ理由を三つ教えて下さい。',
        answer: '赤石さんとマスターマインドっていうので非常に信頼出来るから。と、赤石さんが非常に、税理士であり公認会計士でもあるから。普通の税理士さんと違うから。それとやっぱ、マーケティングについて詳しくて、私と普通に話が出来る、私の困ってること、相談したことに対して必ず答えてくれる。'
      },
      {
        question: '今この商品をどう活用していますか？',
        answer: '毎月必ず１回会って、自分の今やってる事業の方向性を話合って、今後の方向性と自分の頭の整理を毎月１回してます。'
      },
      {
        question: 'この商品の良いところ三つを教えてください。',
        answer: 'この商品の良いところは、赤石さんと対面できっちりと話合って自分の頭の整理が出来るところ、それとまぁ、プライベートのことも普通に相談出来て、家の購入のこと、こうしたらいいよとか、そういうアドバイスも、税金以外のことでも相談出来るところ。あともう１個、なんやろな。やっぱりどんなことに対しても前向きで話を捉えてくれるので、非常に私的に助かる。'
      },
      {
        question: '悪いところ三つを教えてください。',
        answer: '悪いところか。他、税理士を知らないけど、悪いところ、うーん。話が長い。いつも打ち合わせして、いつも何時間？６時間ぐらい？６時から１０時くらい、４時間。長いよね、長い。別に悪くはないんやけど。自分の頭まとまるけど。でも悪いっちゃ悪いと思う。あと二つか、悪いところ・・・・。厳しいところをずかずか言われるので、ちょっとへこむ。まぁ必要なことやけど。悪くはないんやけどな。まぁ若干へこむときがある。悪いところ、無い、分からへん。'
      },
      {
        question: '今後の期待、要望を教えてください。',
        answer: '要望か。もうちょっと時間短縮出来るようにレジュメあるといいかもね。今日のレジュメみたいな。双方で出し合って項目について話し合って、あとはフリーディスカッション１時間で、合計２時間ぐらいで出来たらええかな。あと今後の期待。グループディスカッションみたいなの出来るといいかな。他あるかな。税務の基本的な、超基本的なことを簡単にまとめるようなセミナー、レクチャーみたいなのを毎回ちょっと入れるといいかもしれない。私があまりにも税務のこと無知なんで。そんなとこかな。以上。'
      }
    ]
  };

  const otherTestimonials = [
    {
      name: '仲井 美和',
      company: '関西ビジネスサテライト',
      title: '代表取締役',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/127d7ef9c2e9720f90b5b1713d70cfca.png',
      link: '/testimonials/interview/nakai-miwa'
    },
    {
      name: '井上様',
      company: '株式会社フラブ',
      title: '代表',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/35b8762a66e1873ce7fb0f80abf5f547.png',
      link: '/testimonials/interview/inoue'
    },
    {
      name: '尾西様',
      company: 'コンサルティング事業',
      title: '代表',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/01b737107832c8916c5b9b65ecaa5c33.png',
      link: '/testimonials/interview/onishi'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            {/* 戻るボタン */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              className="mb-8"
            >
              <a
                href="/testimonials"
                className="inline-flex items-center gap-2 text-gray-600 hover:text-red transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
                <span className="text-sm font-medium">お客様の声一覧に戻る</span>
              </a>
            </motion.div>

            {/* ヘッダー */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-16"
            >
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                お客様インタビュー
              </h1>
              <p className="text-xl text-gray-600">
                {testimonial.company} {testimonial.name}様
              </p>
            </motion.div>

            {/* コンテンツ */}
            <div className="grid lg:grid-cols-5 gap-12">
              {/* 左側：プロフィール */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
                className="lg:col-span-2"
              >
                <div className="sticky top-8">
                  <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-8">
                    <div className="w-full" style={{ aspectRatio: '1920/1080' }}>
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-8 border border-red/10">
                    <h3 className="text-3xl font-bold text-red mb-4">
                      {testimonial.company}
                    </h3>
                    <p className="text-gray-600 mb-2">{testimonial.title}</p>
                    <p className="text-xl font-medium text-gray-900">
                      {testimonial.name}
                      <span className="text-lg text-gray-600 ml-2 font-normal">様</span>
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* 右側：インタビュー内容 */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
                className="lg:col-span-3"
              >
                <div className="space-y-10">
                  {testimonial.sections.map((section, index) => (
                    <motion.div
                      key={index}
                      id={index === 0 ? "interview-content" : undefined}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.4 + index * 0.1 }}
                      className="bg-white rounded-2xl p-8 border border-gray-100 hover:border-red/20 hover:shadow-lg transition-all"
                    >
                      <div className="flex items-start gap-4 mb-6">
                        <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-red font-bold text-sm">Q{index + 1}</span>
                        </div>
                        <h4 className="text-xl font-bold text-gray-900 leading-relaxed pt-1">
                          {section.question}
                        </h4>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-10 h-10 bg-red-light/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-red-light font-bold text-sm">A</span>
                        </div>
                        <div className="text-gray-700 leading-relaxed pt-1">
                          <p className="mb-3">
                            {section.answer}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>

                {/* CTA */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 }}
                  className="mt-16 bg-gradient-to-br from-red-dark to-red rounded-3xl p-12 text-center"
                >
                  <h3 className="text-3xl font-bold text-white mb-4">
                    あなたも「勝つ経営」を実現しませんか？
                  </h3>
                  <p className="text-white/90 mb-8 text-lg">
                    無料相談で、あなたのビジネスの可能性を一緒に探りましょう
                  </p>
                  <a
                    href="/#contact"
                    className="inline-block bg-white text-red px-12 py-4 rounded-full text-[15px] font-medium hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
                  >
                    無料相談を予約する
                  </a>
                </motion.div>

                {/* Other Testimonials Section */}
                <section className="py-20 bg-gradient-to-br from-red/5 via-white to-red-light/5">
                  <div className="max-w-7xl mx-auto px-6">
                    <motion.h2
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12"
                    >
                      他のお客様の声
                    </motion.h2>
                    <div className="grid md:grid-cols-3 gap-8">
                      {otherTestimonials.map((testimonial, index) => (
                        <motion.a
                          key={testimonial.id}
                          href={testimonial.link}
                          initial={{ opacity: 0, y: 30 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: index * 0.1 }}
                          className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all cursor-pointer"
                        >
                          <div className="relative" style={{ aspectRatio: '1920/1080' }}>
                            <img
                              src={testimonial.image}
                              alt={testimonial.name}
                              className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-12">
                              <div className="text-center">
                                <div className="inline-flex items-center gap-2 bg-white text-red px-8 py-3 rounded-full font-medium">
                                  <span>詳しく見る</span>
                                  <i className="ri-arrow-right-line"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="p-6 bg-gradient-to-br from-red/5 to-red-light/5 border-t border-red/10">
                            <h3 className="text-xl font-bold text-red mb-2">
                              {testimonial.company}
                            </h3>
                            <p className="text-gray-600 text-sm mb-1">{testimonial.title}</p>
                            <p className="text-lg font-medium text-gray-900">
                              {testimonial.name}
                            </p>
                          </div>
                        </motion.a>
                      ))}
                    </div>
                  </div>
                </section>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default OkadaManabuPage;
